import React, { useState, useEffect } from "react";
import { AssembliesView } from "../../views";
import { useTranslation } from "react-i18next";
import { LocalStorageService, AssembliesService } from "../../../services";
import { arrNoRepetElements, convertToStandarDate, getNavigatorTimezone } from "../../../utils";
import moment from 'moment';

const AssembliesAction = (props) => {
    let {
        location,
        history
    } = props

    let { t } = useTranslation()

    const url = process.env.REACT_APP_MIFIRMA_API;
    const timezone = getNavigatorTimezone()

    const localStorageService = new LocalStorageService();

    const token = localStorageService.getLocalStorageItem("token").idToken;
    const preferredLanguage = localStorageService.getLocalStorageItem("preferredLanguage")
    const language = preferredLanguage || "es"
    moment.locale(language);
    const [loading, setLoading] = useState(true)

    let optionsStatus = [{ name: t("assembliesAction.status.all") }]

    const [titleHeader, setTitleHeader] = useState(t("assembliesAction.header.title"))
    const [nameComponent, setNameComponent] = useState('principal')
    const [showLoadingRequesting, setShowLoadingRequesting] = useState(false)
    const [showCompletedRequesting, setShowCompletedRequesting] = useState(false)
    const [showErrorRequesting, setShowErrorRequesting] = useState(false)
    const [messageComplete, setMessageComplete] = useState('')
    const [messageError, setMessageError] = useState('')
    const [assemblies, setAssemblies] = useState([])
    const [statusFilter, setStatusFilter] = useState([])
    const [assemblySelected, setAssemblySelected] = useState({})
    const [companies, setCompanies] = useState([])
    const [showErrorNoCompanies, setShowErrorNoCompanies] = useState(false)

    useEffect(() => {
        getAssemblies()
    }, [])

    const toggleLoadingRequesting = (value) => {
        setShowLoadingRequesting(value)
    };

    const toggleCompletedRequesting = (time, sendInbox, path, message) => {
        let sendTo = (path && path !== '') ? path : "/help-desk"
        setShowCompletedRequesting(true)
        setMessageComplete(message || '')
        setTimeout(() => {
            setShowCompletedRequesting(false)
            setMessageComplete('')
            if (sendInbox) {
                const locationState = location.state
                if (locationState && locationState.from) {
                    history.push({
                        pathname: locationState.from,
                        state: locationState
                    })
                } else {
                    history.push(sendTo);
                }
            }
        }, time || 4000)
    }

    const toggleErrorRequesting = (message, time, sendInbox, path) => {
        let sendTo = (path && path !== '') ? path : "/help-desk"
        setShowErrorRequesting(true)
        setMessageError(message || '')
        setTimeout(() => {
            setShowErrorRequesting(false)
            setMessageComplete('')
            if (sendInbox) {
                const locationState = location.state
                if (locationState && locationState.from) {
                    history.push({
                        pathname: locationState.from,
                        state: locationState
                    })
                } else {
                    history.push(sendTo);
                }
            }
        }, time || 4000)
    }

    const toggleErrorRequestingFalse = () => {
        setShowErrorRequesting(false)
    }

    const changePage = (nameComponent, titleHeader) => {
        setTitleHeader(titleHeader || t("assembliesAction.header.title"))
        setNameComponent(nameComponent || 'principal')
    }

    const getAssemblies = async () => {
        setLoading(true)
        let messageError = t("assembliesAction.errors.assembly")
        try {
            let assembliesClient = await AssembliesService.getAssemblies(timezone, token)
            if (assembliesClient && assembliesClient.data && Number(assembliesClient.statusCode) === 200) {
                let newAssemblies = assembliesClient.data.map(assembly => {
                    let convertDate = convertToStandarDate(assembly.date, language)
                    assembly.dateFormatted = convertDate
                    return assembly
                })

                let statusAsemblies = getStatus(assembliesClient.data)
                let allStatus = optionsStatus.concat(statusAsemblies)

                setStatusFilter(allStatus)
                setAssemblies(newAssemblies)
                await getCompanies()
                toggleLoadingRequesting(false)
                setLoading(false)
                // toggleCompletedRequesting(4000, false, "/", null)
            } else {
                setLoading(false)
                toggleErrorRequesting(messageError, 4000, true, "/help-desk")
            }
        } catch (error) {
            if (error && error.response && error.response.data && error.response.data.statusCode && error.response.data.statusCode === 410) messageError = t("assembliesAction.errors.permissions")
            setLoading(false)
            toggleErrorRequesting(messageError, 4000, true, "/help-desk")
        }
    }

    const getStatus = (assemblies) => {
        let allStatus = []
        let assembliesFilter = []

        assemblies.forEach(assembly => {
            if (assembly.status) {
                assembliesFilter.push(assembly.status)
            }
        })

        assembliesFilter = arrNoRepetElements(assembliesFilter)

        allStatus = assembliesFilter.map(assembly => {
            let data = {
                name: assembly
            }

            return data
        });

        return allStatus
    }

    const getCompanies = async () => {
        try {
            let companies = await AssembliesService.getCompaniesAssemblies(token)
            if (companies.statusCode === 200) {
                let allCompanies = companies.data
                if (allCompanies.length === 0) setShowErrorNoCompanies(true)
                setCompanies(allCompanies)
            } else {
                setShowErrorNoCompanies(true)
            }
        } catch (e) {
            toggleLoadingRequesting(false)
            toggleErrorRequesting(messageError, 4000, true, "/help-desk")
        }
    }

    return (
        <AssembliesView
            {...props}
            t={t}
            isLoadingView={loading}
            titleHeader={titleHeader}
            nameComponent={nameComponent}
            toggleLoadingRequesting={toggleLoadingRequesting}
            toggleCompletedRequesting={toggleCompletedRequesting}
            toggleErrorRequesting={toggleErrorRequesting}
            toggleErrorRequestingFalse={toggleErrorRequestingFalse}
            showLoadingRequesting={showLoadingRequesting}
            showCompletedRequesting={showCompletedRequesting}
            showErrorRequesting={showErrorRequesting}
            messageComplete={messageComplete}
            messageError={messageError}

            companies={companies}
            assemblies={assemblies}
            statusFilter={statusFilter}
            getAssemblies={getAssemblies}
            setAssemblies={setAssemblies}
            changePage={changePage}
            assemblySelected={assemblySelected}
            setAssemblySelected={setAssemblySelected}
            showErrorNoCompanies={showErrorNoCompanies}
        />
    )
}

export { AssembliesAction as default }